export default __webpack_public_path__ + "static/media/shop-search.b34f5a53.svg";